export default {"src":"/_next/static/media/404_Ping.54ac648c.svg","height":246,"width":306};